import React from 'react'
import List from '../components/List'
import hipladeTemplate from '../../common/template'

function StudentsGroupList() {
  return <List />
}

export default hipladeTemplate(StudentsGroupList)
